export default "__VITE_ASSET__DkZ3HNNZ__"